import { BenefitsActiveMarketsDocument } from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { SupportedMarket } from 'modules/benefits/lib/supportedMarkets'

export function useActiveMarkets(): {
  activeMarkets: SupportedMarket[]
  loading: boolean
} {
  const { data, loading } = useQuery(BenefitsActiveMarketsDocument)

  const activeMarkets: SupportedMarket[] = useUnsafeMemo(() => {
    const markets: SupportedMarket[] = []
    if (data?.companies.portugalActive?.available) markets.push('pt')

    // We are currently missing more accurate checks to guarantee
    // that Spain is set up rather than PT. We will need to improve our
    // support for multi-national companies.
    if (data?.companies.spainActive?.available && !markets.includes('pt')) markets.push('es')

    return markets
  }, [data])

  return { activeMarkets, loading }
}
